import { Box, Link, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ReactComponent as MaintenanceIcon } from "../../assets/MaintenanceIcon.svg";
import { Footer, NavbarPanel } from "@web-applications/allinga-web-components";
import { PATHS } from "../constants";
import { runtimeConfig } from "../config/runtime-config-loader";

export default function MaintenancePage() {
  const { t, i18n } = useTranslation();
  const emailId = "plattform@allinga-plattform.de";

  const handleOpenEmail = () => {
    window.open(`mailto:${emailId}`, "_blank");
  };

  const { maintenanceMessageDe, maintenanceMessageEn } = runtimeConfig;

  const maintenanceMessage =
    i18n.language === "de" ? maintenanceMessageDe : maintenanceMessageEn;

  return (
    <Stack
      bgcolor="white"
      justifyContent="space-between"
      sx={{ minHeight: "100vh" }}
    >
      <NavbarPanel leftGrid={null} rightGrid={null} />

      <Stack justifyContent="center" alignItems="center" sx={{ flexGrow: 1 }}>
        <MaintenanceIcon />

        <Box
          sx={{
            mt: 5,
            maxWidth: 516,
            textAlign: "center",
          }}
        >
          <Typography variant="h4" sx={{ mb: 3, fontWeight: 500 }}>
            {t("maintenanceHeader")}
          </Typography>

          <Typography variant="body1">
            {maintenanceMessage || t("maintenanceText1")}{" "}
            <Link
              color="primary"
              onClick={handleOpenEmail}
              sx={{ cursor: "pointer" }}
            >
              {emailId}
            </Link>
          </Typography>
        </Box>
      </Stack>

      <Footer
        copyrightUrl={PATHS.copyright}
        thirdPartyNoticesUrl={PATHS.thirdPartyNotices}
        shouldUseDefault={false}
        imprintUrl={PATHS.imprint}
        privacyUrl={PATHS.privacy}
      />
    </Stack>
  );
}
